import React from "react"

import { graphql } from "gatsby"
import UnstyledImg from "gatsby-image"
import styled from "styled-components"

import Page from "../components/page"

export default ({ data }) => {
  const { node } = data.allWordpressPost.edges[0]

  return (
    <Page title={`${node.title} | ニュース`} titleElement="h2">
      <Article>
        {node.featured_media && (
          <Img
            fluid={node.featured_media.localFile.childImageSharp.fluid}
            maxWidth={node.featured_media.media_details.width}
          />
        )}
        <Title>{node.title}</Title>
        <Body dangerouslySetInnerHTML={{ __html: node.content }}></Body>
      </Article>
    </Page>
  )
}

export const pageQuery = graphql`
  query PostById($id: String!) {
    allWordpressPost(filter: { id: { eq: $id } }) {
      edges {
        node {
          id
          title
          content
          featured_media {
            media_details {
              width
            }
            localFile {
              childImageSharp {
                fluid(maxWidth: 960) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
        }
      }
    }
  }
`

const Article = styled.article`
  grid-column: 2 / 3;
`

const Img = styled(UnstyledImg)`
  margin: 0 0 2rem;
  max-width: ${({ maxWidth }) => maxWidth}px;
`

const Title = styled.h1`
  margin: 0 0 2rem;
  padding: 0 0 2rem;
  border-bottom: 0.8rem solid ${({ theme }) => theme.colors.accent};
  font-size: 2.5rem;
  font-weight: 100;
`

const Body = styled.div`
  width: 100%;
  max-width: 34em;
  font-weight: 200;

  figure {
    margin: 1rem 0;
  }

  img {
    max-width: 100%;
  }
`
